import React from 'react';
import { string } from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';
import { dateTimeFormat, DATETIME_ELEMENT_STYLES } from '@fiverr-private/localization';

const DateDisplay = ({ date }) => {
    if (!date) {
        return null;
    }

    const dateSplit = date.split('-');

    return (
        <span>
            { dateTimeFormat(new Date(date), {
                year: DATETIME_ELEMENT_STYLES.NUMERIC,
                month: DATETIME_ELEMENT_STYLES.SHORT,
                fallbackValue: <><I18n k={`months.abbrv.${parseInt(dateSplit[1], 10)-1}`}/>&nbsp;{dateSplit[0]}</>
            })}
        </span>
    );
};

DateDisplay.propTypes = {
    date: string // Ex. "2017-04-01"
};

export default DateDisplay;
